import React, { Component } from "react";
import CategoryFilter from "../../assets/CategoryFilter";

class ProductsFilterBlock extends Component {
  render() {
    return (
      <div className="row mx-0 px-4">
        <div className="col-12 px-0 text-start">
          <div
            className="d-inline-block"
            onClick={() => {
              this.props.changeRows(this.props.rowsCount === 1 ? 2 : 1);
              localStorage.setItem(
                "productsItemCount",
                this.props.rowsCount === 1 ? 2 : 1
              );
            }}
          >
            <CategoryFilter rowsCount={this.props.rowsCount} />
          </div>
        </div>
      </div>
    );
  }
}

export default ProductsFilterBlock;
